import React from 'react'
import styled from 'styled-components'

// Import Page Level Components
import NavPrimary from '../../components/layouts/NavPrimary.js'
import SecondaryNav from '../../components/layouts/NavSecondary.js'
import TertiaryNavActiveInvoicePaid from '../../components/layouts/TertiaryNav/TertiaryNavInvoicePaid.js'
import Footer from '../../components/layouts/Footer.js'

import GContentInvoicePaid from '../../components/ContentGrids/Invoices/PaidInvoiceContentGrid.js'

const PGInvoicePaid = styled.div`
  height: 100vh;
  background-color: #fff;
  // 🖋
  font-family: 'Open Sans';
  color: #0033a1;
  // 📰
  display: grid;
  grid-template-rows: 0.1fr 0.3fr 0.2fr 5fr 0.2fr;
  grid-template-columns: 1fr;
  grid-template-areas:
    "nav_secondary"
    "nav_primary"
    "nav_tertiary"
    "g_content"
    "g_footer";

  .NavPrimary {
    grid-area: nav_primary; // 🗺
    align-self: start;
  }
  .SecondaryNav {
    grid-area: nav_secondary; // 🗺
    align-self: start;
  }
  .TertiaryNavActiveInvoicePaid {
    grid-area: nav_tertiary; // 🗺
    align-self: start;
  }
  .GContentShipment {
    grid-area: g_content; // 🗺
  }
  .Footer {
    grid-area: g_footer; // 🗺
    align-self: end;
  }
`

const PageGridComponentQuotes = () => {
  return (
    <PGInvoicePaid>
      <SecondaryNav></SecondaryNav>
      <NavPrimary></NavPrimary>
      <TertiaryNavActiveInvoicePaid></TertiaryNavActiveInvoicePaid>

        <GContentInvoicePaid></GContentInvoicePaid>

      <Footer></Footer>
    </PGInvoicePaid>
  )
}

export default PageGridComponentQuotes;